import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_DELIVERY_SOFTWARE = `${URL_RETAILER_SCOPED}/delivery-software`
const URL_DELIVERY_SOFTWARE_DELIVERY_ROUTES = `${URL_DELIVERY_SOFTWARE}/delivery-routes`
const URL_DELIVERY_SOFTWARE_DELIVERY_ROUTE_DETAIL = `${URL_DELIVERY_SOFTWARE_DELIVERY_ROUTES}/:mode/:batchId`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  | 'delivery-software'
  | 'delivery-software-delivery-routes'
  | 'delivery-software-delivery-route-detail'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'delivery-software': URL_DELIVERY_SOFTWARE,
  'delivery-software-delivery-routes': URL_DELIVERY_SOFTWARE_DELIVERY_ROUTES,
  'delivery-software-delivery-route-detail': URL_DELIVERY_SOFTWARE_DELIVERY_ROUTE_DETAIL,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
